import { Attrs, MinzeAttrs, MinzeElement } from 'minze'
import { Font } from '../../../constants'

interface FontPreset {
  fontSize: string
  color: string
  fontWeight: string
}

const fontPresets: Record<string, FontPreset> = {
  small: {
    fontSize: '14px',
    color: '#1E007D',
    fontWeight: Font.weight.medium,
  },
  medium: {
    fontSize: '18px',
    color: '#1E007D',
    fontWeight: Font.weight.medium,
  },
  large: {
    fontSize: '20px',
    color: '#1E007D',
    fontWeight: Font.weight.medium,
  },
  smallExtraBold: {
    fontSize: '14px',
    color: '#1E007D',
    fontWeight: Font.weight.extraBold,
  },
  mediumExtraBold: {
    fontSize: '18px',
    color: '#1E007D',
    fontWeight: Font.weight.extraBold,
  },
  largeExtraBold: {
    fontSize: '20px',
    color: '#1E007D',
    fontWeight: Font.weight.extraBold,
  },
  titleDesktop: {
    fontSize: '90px',
    color: '#1E007D',
    fontWeight: Font.weight.extraBold,
  },
  titleDesktopSmall: {
    fontSize: '36px',
    color: '#1E007D',
    fontWeight: Font.weight.extraBold,
  },
  titleMobile: {
    fontSize: '36px',
    color: '#1E007D',
    fontWeight: Font.weight.extraBold,
  },
  titleMobileSmall: {
    fontSize: '24px',
    color: '#1E007D',
    fontWeight: Font.weight.extraBold,
  },
  xLargeMediumBold: {
    fontSize: '24px',
    color: '#1E007D',
    fontWeight: Font.weight.medium,
  },
  MediumMediumBold: {
    fontSize: '18px',
    color: '#1E007D',
    fontWeight: Font.weight.medium,
  },
}

export class LvcText extends MinzeElement {
  attrs: MinzeAttrs = [
    ['color', '#1E007D'],
    ['font-weight'],
    ['text-align'],
    'white-space',
    'text-decoration',
    'text-transform',
    ['line-height'],
    'font-preset',
    ['font-size'],
  ]

  get fontPreset(): FontPreset {
    return fontPresets[this.getAttribute('font-preset') || 'medium']
  }

  html = () => `
    <div class="text" part="text">
      <slot></slot>
    </div>
  `

  css = () => `
    .text {
      font-family: ${Font.family};
      color: ${this.getAttribute('color') || this.fontPreset.color || '#1E007D'};
      font-size: ${this.getAttribute('font-size') || this.fontPreset.fontSize};
      text-align: ${this.textAlign};
      font-weight: ${this.getAttribute('font-weight') || this.fontPreset.fontWeight || Font.weight.medium};
      ${this.whiteSpace ? `white-space: ${this.whiteSpace};` : ''};
      ${this.textDecoration ? `text-decoration: ${this.textDecoration};` : ''};
      ${this.textTransform ? `text-transform: ${this.textTransform};` : ''};
      line-height: ${this.getAttribute('line-height') || ''};
    }
  `
}
